import { createFileRoute, redirect } from '@tanstack/react-router'
import { createServerFn } from '@tanstack/react-start'
import { getRequest } from '@tanstack/react-start/server'
import { LandingPage } from '#/components/landing/landing-page'
import { m } from '#/paraglide/messages'

/** Signed-in visitors skip the marketing page and land on the workspace home (plane.so → app.plane.so). */
const isSignedIn = createServerFn({ method: 'GET' }).handler(async () => {
  const { getSessionFromRequest } = await import('#/lib/session.server')
  const s = await getSessionFromRequest(getRequest()).catch(() => null)
  return Boolean(s?.user)
})

export const Route = createFileRoute('/')({
  beforeLoad: async () => {
    if (await isSignedIn()) throw redirect({ to: '/home' })
  },
  head: () => ({
    links: [{ rel: 'canonical', href: 'https://bystep.dev/' }],
    meta: [
      { title: m.mk_meta_title() },
      { name: 'description', content: m.mk_meta_desc() },
      { property: 'og:title', content: m.mk_meta_title() },
      { property: 'og:description', content: m.mk_meta_desc() },
      { property: 'og:type', content: 'website' },
      { property: 'og:image', content: 'https://bystep.dev/brand/bystep-og.png' },
      { property: 'og:url', content: 'https://bystep.dev/' },
      { property: 'og:image:width', content: '1200' },
      { property: 'og:image:height', content: '630' },
      { name: 'twitter:card', content: 'summary_large_image' },
      { name: 'twitter:title', content: m.mk_meta_title() },
      { name: 'twitter:description', content: m.mk_meta_desc() },
      { name: 'twitter:image', content: 'https://bystep.dev/brand/bystep-og.png' },
    ],
  }),
  component: LandingPage,
})
